import React, { Component } from 'react';
import {TextField} from 'rmwc/TextField';
import {Button} from 'rmwc/Button';
import { Select } from 'rmwc/Select';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import * as api from '../../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux'
import StatusMessage from '../../util/StatusMessage'
import AdminRoadmapDisplay from './AdminRoadmapDisplay';
import AdminCompetency from './AdminCompetency';


class MCRoadmaps extends Component{
  constructor(props) {
    super(props)
    this.state = {
      formOpen: false,
      viewPage: 'initial',
      errorMsg: '',
      data:{
        'mcTopicId': '',
        'roadmapName': '',
        'certificationTypeId': '',
        'mcTopics': []
      }, 
      dispData:{
        'roadmapDetails': [] 
      },
      selectedData:{
        'roadmapName': '',
        'roadmapId': ''
      }
    };
  }

  handleFormOpen = () => {
    this.setState({ formOpen: true, errorMsg: ''});
  }

  handleFormClose = () => {
    let default_data = Object.assign({}, this.state.data)

    default_data.mcTopicId = ''
    default_data.roadmapName = ''
    this.setState({ data: default_data, formOpen: false, errorMsg: ''});
  }

  handleTopicsChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.mcTopicId = event.target.value
    this.setState({data: data})
  }

  handleNameChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.roadmapName = event.target.value
    this.setState({data: data}) 
  }

  handleSubmit = (event) => {
    let data = Object.assign({}, this.state.data)

    if ((this.state.data.mcTopicId === '') || (this.state.data.roadmapName === '')) {
      return this.setState({errorMsg: 'Please enter a Roadmap Name and choose an MC Topic.'})
    }

    let inp = {
      'mc_topic_id' :data.mcTopicId,
      'roadmap_name' : data.roadmapName,
      'certification_type_id' : data.certificationTypeId
    }

    api.adminNewRoadmap(this.props.user.accessToken, inp)
      .then((result) => {
        if(result.status === 'success'){
          let default_data = Object.assign({}, this.state.data)
          default_data.mcTopicId = ''
          default_data.certificationTypeId = ''
          default_data.roadmapName = ''
          this.setState({data: default_data, formOpen: false, errorMsg: '' })
          api.adminRoadmapDisplay(this.props.user.accessToken, 1)
            .then((result) => {
              let dispData = Object.assign({}, this.state.dispData)
              dispData.roadmapDetails = result.data
              this.setState({dispData: dispData})
            })
        }
        else if (result.status === 'error') {
          this.setState({ errorMsg: 'A Roadmap already exists for this MC Topic.' })
        }
        else if (result.status === 'save_error') {
          this.setState({ errorMsg: 'Roadmap not saved. Try again later.' })
        }
      }).catch((err) => {
        this.setState({ errorMsg: 'Error Occurred. Please Contact Admin' })
      })
  }

  handleBackAction = (event) => {
    let viewPage = Object.assign({}, this.state.viewPage)
    viewPage = "initial"
    this.setState({viewPage: viewPage})
  }

  handleRMView = (roadmapId, roadmapName) => {
    let viewPage = Object.assign({}, this.state.viewPage)
    viewPage = "rm_view"
    this.setState({viewPage: viewPage})
    let selectedData = Object.assign({}, this.state.selectedData)
      selectedData.roadmapName = roadmapName
      selectedData.roadmapId = roadmapId
    this.setState({selectedData: selectedData})
  }

  handleEditAction = (e) => {
    let dispData = Object.assign({}, this.state.dispData)

    api.adminRoadmapDisplay(this.props.user.accessToken, 1)
    .then((result) => {
      dispData.roadmapDetails = result.data
      this.setState({dispData: dispData})
    })
  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    let dispData = Object.assign({}, this.state.dispData)

    return api.getMcTopics(this.props.user.accessToken)
        .then((result) => {
          data.mcTopics = result
          this.setState({data: data})
          return api.adminRoadmapDisplay(this.props.user.accessToken, 1)
            .then((result) => {
              dispData.roadmapDetails = result.data
              this.setState({dispData: dispData})
            })
        })
  }

  render() {
    let roadmap
    let roadmapsToShow
    let componentToShow
    if (this.state.formOpen) {
      roadmap = (
        <GridCell span="4">
          <TextField fullwidth label ="Name of the Roadmap"  autoComplete="off"  name="name" value = {this.state.data.roadmapName} onChange = {this.handleNameChange} style={{ height: '140%' }} />
          <br />
          <Select
            name="mcTopic"
            onChange={this.handleTopicsChange}
            value={this.state.data.mcTopicId}
            className="select-component"
            placeholder="--Select MC Topic--">
            {this.state.data.mcTopics.map(mcTopic => (
              <option key={mcTopic.id} value={mcTopic.id} data-name={mcTopic.name}>
                {mcTopic.name}
              </option>
            ))}
          </Select>
          <br />
          <span><Button raised style={{ width: '50%' }} onClick = {this.handleSubmit}>Save</Button>
          <Button style={{ width: '50%' }} onClick={this.handleFormClose}>Cancel</Button></span>
          <StatusMessage error_msg = {this.state.errorMsg} />
        </GridCell>
      )
    }

    if (this.state.dispData.roadmapDetails.length>0){
      let handleRMViewa = this.handleRMView
      let handleEditAction = this.handleEditAction
      let i =0;
      roadmapsToShow = (
      <Grid>
        {this.state.dispData.roadmapDetails.map(function(roadmapDetails){
          i=i+1
          if(i%2 === 0){
          return (<GridCell span="6"><AdminRoadmapDisplay roadmapName={roadmapDetails.name}
            mcTopicId = {roadmapDetails.mcTopicId}
            roadmapId = {roadmapDetails.id}
            certificationTypeId = {roadmapDetails.certificationTypeId}
            onHandleRmView = {handleRMViewa} 
            handleEditAction = {handleEditAction}/></GridCell>)
          }
          else{
            return (<GridCell span="6"><AdminRoadmapDisplay roadmapName={roadmapDetails.name}
            mcTopicId = {roadmapDetails.mcTopicId}
            roadmapId = {roadmapDetails.id}
            certificationTypeId = {roadmapDetails.certificationTypeId}
            onHandleRmView = {handleRMViewa} 
            handleEditAction = {handleEditAction}/></GridCell>)
          } 
          })}
        </Grid>
        )
    }

    if (this.state.viewPage === 'initial') {
      componentToShow = (
        <Grid>
          <GridCell span="12">
            <form style={{width: '100%'}}>
              <Card style={{padding: '25px'}}>
                <Typography use="headline5">MyCENTA Learning Resources</Typography>
              </Card>
            </form> 
            <button className="mdc-button" align = "left" aria-label="Favorite" onClick={this.handleFormOpen}>
              Add Learning Resources
            </button>
          </GridCell> 
            {roadmap}
          <GridCell span="12">
            <div>
              <Typography use="headline6">MC - Learning Resources</Typography>
            </div>
            <br/>
            {roadmapsToShow}
          </GridCell> 
        </Grid>
      )
    }
    else if (this.state.viewPage === 'rm_view') {
      componentToShow = (
        <AdminCompetency roadmapName = {this.state.selectedData.roadmapName}
        roadmapId = {this.state.selectedData.roadmapId} 
        handleBackAction = {this.handleBackAction} />
      )
    }

		return (
      <div>
        {componentToShow}
      </div>
    	);
	}
}



function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MCRoadmaps);


// WEBPACK FOOTER //
// ./src/views/admin/MCRoadmaps.jsx